/**
 * @hidden
 */
export var ActiveDescendant;
(function (ActiveDescendant) {
    ActiveDescendant[ActiveDescendant["PopupList"] = 0] = "PopupList";
    ActiveDescendant[ActiveDescendant["TagsList"] = 1] = "TagsList";
})(ActiveDescendant || (ActiveDescendant = {}));
//# sourceMappingURL=settings.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-react-dropdowns/dist/es/common/settings.js
// module id = 440
// module chunks = 0